import React from "react";
import moment from "moment";
import {
  getField,
  deserializeField,
  tooltip,
  formatDate,
} from "../../util/DynamicItemUtils";

export default function InspectionReport({ item }: any) {
  const dateParsingFormat = "YYYY-MM-DDTHH:mm:ssZ";
  const dateDisplayFormat =
    getField(item, "effectivedate") &&
    formatDate(getField(item, "effectivedate"));

  const modalId =
    "public-criticism-" +
    getField(item, "title")
      .replace(/[^\w\s]/gi, "")
      .replace(/\s+/g, "");
  const modalHref = "#" + modalId;

  return (
    <div>
      <p className="lead-text-lt">{getField(item, "contenttypelabel")}</p>
      {getField(item, "name") ? (
        <h3>
          <a
            href={deserializeField(item, "name")[0].mediaUrl}
            download
            target="_blank"
          >
            {getField(item, "title")}
          </a>
        </h3>
      ) : (
        <h3>{getField(item, "title")}</h3>
      )}
      <div className="hawk-row inline">
        {getField(item, "country") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Country</div>
            <div className="lead-text-st">{getField(item, "country")}</div>
          </div>
        )}
        {getField(item, "globalnetworks") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Global Network</div>
            <div className="lead-text-st">{getField(item, "globalnetworks")}</div>
          </div>
        )}
        {getField(item, "inspectionyear") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Inspection Year</div>
            <div className="lead-text-st">{getField(item, "inspectionyear")}</div>
          </div>
        )}
        {getField(item, "totalissuerauditclients") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Total Issuer Audit Clients</div>
            <div className="lead-text-st">{getField(item, "totalissuerauditclients")}</div>
          </div>
        )}
        {getField(item, "totalauditsreviewed") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Audits Reviewed</div>
            <div className="lead-text-st">{getField(item, "totalauditsreviewed")}</div>
          </div>
        )}
        {getField(item, "partiadeficiencyrate") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Part I.A Deficiency Rate</div>
            <div className="lead-text-st">{getField(item, "partiadeficiencyrate")}%</div>
          </div>
        )}
        {getField(item, "effectivedate") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Inspection report date</div>
            <div className="lead-text-st">
              {getField(item, "effectivedate")
                ? moment(
                    getField(item, "effectivedate"),
                    dateParsingFormat
                  ).format(dateDisplayFormat)
                : null}
            </div>
          </div>
        )}
      </div>
      <div>
        {deserializeField(item, "name") && (
          <a
            href={deserializeField(item, "name")[0].mediaUrl}
            className="hawk-download-pdf"
            target="_blank"
          >
            Download PDF
          </a>
        )}
      </div>
      {getField(item, "expandeddisclosure") &&
        (getField(item, "expandeddisclosure") === "Yes" ? (
          <div className="hawk-modal-box">
            <button
              type="button"
              className="hawk-modal-link"
              aria-label="more info"
              data-toggletip-content='If an inspection report notes that it "includes public quality control criticisms," that means that the PCAOB made public additional portions of the previously issued inspection report because the firm did not address certain quality control issues to the satisfaction of the Board within the 12 months following the date of the report.'
              onClick={tooltip}
            >
              Includes public quality control criticisms
            </button>
            <span role="status"></span>
          </div>
        ) : (
          ""
        ))}
    </div>
  );
}
